import { CustomerReferenceProvider } from "@repo/ui/structuredContent/customerReferenceContext";
import {
  GradingReferenceProvider,
  type GradingReferenceWrapper,
} from "@repo/ui/structuredContent/gradingReferenceContext";
import { PlaybookFeedbackReferenceProvider } from "@repo/ui/structuredContent/playbookFeedbackReferenceContext";
import { TeammateGroupReferenceProvider } from "@repo/ui/structuredContent/teammateGroupReferenceContext";
import { TeammateReferenceProvider } from "@repo/ui/structuredContent/teammateReferenceContext";
import type { FC, ReactNode } from "react";
import { CustomerReferenceLinkAdapter } from "../teammatePerformance/customerReferenceLinkAdapter.js";
import { GradingReferenceLinkAdapter } from "../teammatePerformance/gradingReferenceLinkAdapter.js";
import { PlaybookFeedbackReferenceLinkAdapter } from "../teammatePerformance/playbookFeedbackReferenceLinkAdapter.js";
import { TeammateGroupReferenceLinkAdapter } from "../teammatePerformance/teammateGroupReferenceLinkAdapter.js";
import { TeammateReferenceLinkAdapter } from "../teammatePerformance/teammateReferenceLinkAdapter.js";

interface StructuredContentReferenceProvidersProps {
  /** Replaces the default grading link, e.g. to open the interaction in place. */
  gradingReferenceWrapper?: GradingReferenceWrapper;
  children: ReactNode;
}

/**
 * The link adapters for every reference kind structured content can contain:
 * chat transcripts, saved artifacts and coaching content alike. Add new kinds
 * here so each surface picks them up.
 */
export const StructuredContentReferenceProviders: FC<
  StructuredContentReferenceProvidersProps
> = (props) => {
  const { gradingReferenceWrapper, children } = props;
  return (
    <GradingReferenceProvider
      value={gradingReferenceWrapper ?? GradingReferenceLinkAdapter}
    >
      <TeammateReferenceProvider value={TeammateReferenceLinkAdapter}>
        <TeammateGroupReferenceProvider
          value={TeammateGroupReferenceLinkAdapter}
        >
          <CustomerReferenceProvider value={CustomerReferenceLinkAdapter}>
            <PlaybookFeedbackReferenceProvider
              value={PlaybookFeedbackReferenceLinkAdapter}
            >
              {children}
            </PlaybookFeedbackReferenceProvider>
          </CustomerReferenceProvider>
        </TeammateGroupReferenceProvider>
      </TeammateReferenceProvider>
    </GradingReferenceProvider>
  );
};
